import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import Icon from '../atoms/Icon';
import TextAnchor from '../atoms/TextAnchor';

//Returning the component
class DropdownMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			activeClass: this.props.activeClass
		}
	}
	componentWillReceiveProps(nextProps) {
		this.setState({ activeClass: nextProps.activeClass })
	}
	render() {
		return (
			<div className={`dropdownMenu ${this.state.activeClass ? 'dropdownMenu--active' : ''}`}>
				<ul className="dropdownMenu__list">
					<li className="dropdownMenu__listItem" onClick={this.props.onClick}>
						<Icon classType={this.props.iconType} />
						<TextAnchor text="Logout"/>
					</li>
				</ul>
			</div>
		)
	}
}

//Default properties if they are not set
DropdownMenu.defaultProps = {
	iconType: ""
};

DropdownMenu.propTypes = {
	listItem: PropTypes.string,
	href: PropTypes.string,
	iconType: PropTypes.string
}
export default DropdownMenu;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/DropdownMenu.jsx